import { Cell } from '@/components/Bicester/Table/Cells/index';
import { BICESTER_FULL_DATE } from '@/constants/dateFormat';
import dayjs from 'dayjs';
import React from 'react';

export interface DateTimeCellProps {
  rowData?: BaseObject<any>;
  dataKey: string;
  format?: string;
  showPlaceholder?: boolean;
}

const DateTimeCell = ({
  rowData,
  dataKey,
  format = BICESTER_FULL_DATE,
  showPlaceholder = true,
  ...props
}: DateTimeCellProps) => {
  const data = rowData?.[dataKey] ?? null;
  return (
    <Cell {...props}>
      <span>{data ? dayjs(data).format(format) : showPlaceholder ? '--' : ''}</span>
    </Cell>
  );
};

export default React.memo(DateTimeCell);
